import EditPatientPage from './EditPatientPage'

export default EditPatientPage
